import { z } from 'zod';
// Viewer-private in-app notification DTO returned by `/notifications`.
export const Notification = z.object({
    id: z.string().uuid(),
    kind: z.string().min(1).max(128),
    reason: z.string().min(1).max(128),
    title: z.string().min(1).max(240),
    body: z.string().max(2000),
    actionUrl: z.string().min(1).max(2048),
    actorKind: z.string().min(1).max(64),
    actorId: z.string().min(1).max(128),
    subjectKind: z.string().min(1).max(64),
    subjectId: z.string().min(1).max(128),
    aggregateCount: z.number().int().positive().default(1),
    aggregateWindowStartedAt: z.string().datetime({ offset: true }),
    aggregateWindowEndsAt: z.string().datetime({ offset: true }).nullable(),
    aggregateLastAt: z.string().datetime({ offset: true }).nullable(),
    fromActivityId: z.string().uuid().nullable(),
    readAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
});
export const NotificationFilter = z.enum(['all', 'unread', 'read']);
//# sourceMappingURL=notification.js.map